import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Visitor} from '../classes/Visitor';
import {OrdersView} from '../enums/OrdersView';
import {Page} from '../classes/Page';
import {VisitorStatus} from '../enums/VisitorStatus';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root'
})
export class VisitorsService {

  constructor(private httpClient: HttpClient) { }

  public getAllVisitors(
    startDate: Date,
    endDate: Date,
    visitorStatus: VisitorStatus,
    pageNumber: number,
    pageSize: number
  ): Observable<Page<Visitor>> {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: new HttpParams()
        .append('start', startDate.toDateString())
        .append('end', endDate.toDateString())
        .append('status', visitorStatus)
        .append('pageNumber', pageNumber)
        .append('pageSize', pageSize)
    };
    return this.httpClient.get<Page<Visitor>>(`${environment.backendApiUrl}/v1/visitors`, options);
  }

  public addOrEdit(visitor: Visitor): Observable<void> {
    console.log(visitor);
    return this.httpClient.put<void>(`${environment.backendApiUrl}/v1/visitors`, visitor, httpOptions);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/visitors/` + id, httpOptions);
  }

  public getVisitorsByOrderId(id: number): Observable<Visitor[]> {
    return this.httpClient.get<Visitor[]>(`${environment.backendApiUrl}/v1/visitors/orders/` + id, httpOptions);
  }

  public getVisitorsByUserIdAndOrderStatuses(id: number, ordersView: OrdersView): Observable<Visitor[]> {

    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: new HttpParams().append('view', ordersView)
    };

    return this.httpClient.get<Visitor[]>(`${environment.backendApiUrl}/v1/visitors/users/` + id, options);
  }
}
